export default __webpack_public_path__ + "7d7b52ddc18ddbb0bbf5fbc6a1ba2a4d.svg";